import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: '¿Pasaré hambre?',
  a: 'No, el protocolo prioriza grasas saludables y proteínas que te mantienen saciado.'
}, {
  q: '¿Necesito suplementos caros?',
  a: 'No, todo lo que necesitas está en el supermercado local.'
}, {
  q: '¿Es seguro si tengo 50 o 60 años?',
  a: 'Sí, está diseñado específicamente para la biología de adultos maduros.'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-cream py-20 md:py-28" data-id="element-24">
      <div className="mx-auto max-w-3xl px-6" data-id="element-25">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6
      }} className="mb-12 text-center" data-id="element-26">
          <p className="mb-3 text-xs font-medium uppercase tracking-[0.2em] text-amber" data-id="element-27">
            Resuelve tus dudas
          </p>
          <h2 className="font-serif text-4xl leading-tight text-charcoal md:text-5xl" data-id="element-28">
            Preguntas frecuentes
          </h2>
        </motion.div>

        <div className="divide-y divide-charcoal/10 border-y border-charcoal/10" data-id="element-29">
          {faqs.map((item, i) => {
          const isOpen = open === i;
          return <div key={i} data-id="element-30">
                <button onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center justify-between gap-6 py-6 text-left" aria-expanded={isOpen} data-id="element-31">
                  <span className="font-serif text-lg text-charcoal md:text-xl" data-id="element-32">
                    {item.q}
                  </span>
                  <ChevronDownIcon className={`h-5 w-5 flex-shrink-0 text-amber transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-33" />
                </button>
                <AnimatePresence initial={false} data-id="element-34">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-35">
                      <p className="pb-6 pr-12 text-base leading-relaxed text-charcoal-light" data-id="element-36">
                        {item.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}